var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"start"}},[_c('ion-text',{staticClass:"contact-ways-text"},[_vm._v(_vm._s(_vm.$t('signup.contactWaysTitle')))]),_c('ion-list',{attrs:{"lines":"none"}},_vm._l((_vm.options),function(option){return _c('checkbox',{key:option.id,attrs:{"label":option.value,"optionId":option.id,"checked":_vm.contactWays ? _vm.contactWays.find(function (ref) {
	var id = ref.id;

	return id === option.id;
}) : false},on:{"onChange":_vm.handleChange}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }